import React from 'react';
import PropTypes from 'prop-types';
import PageContainer from 'common/components/PageContainer';
import ButtonBack from 'common/components/ButtonBack';
import TabsHolder from 'common/components/TabsHolder';
import TabProperty from 'modules/InspectedList/components/TabProperty';
import styles from './styles.module.scss';

const backLabel = `חזור לרשימת הנכסים`;

const DatabasePageView = () => (
  <PageContainer>
    <div className={styles.contentContainer}>
      <div className={styles.titleLine}>
        <h1 className={styles.title}>מאגר מסמכים ואסמכתאות</h1>
        <ButtonBack label={backLabel} />
      </div>
      <div className={styles.propContainer}>
        <div className={styles.propLine}>
          <span className={styles.propName}>כתובת הנכס:</span>
          <span className={styles.propDetails}>אברהם יצחק גלמן 307 , מודיעין-מכבים-רעות</span>
        </div>
        <div className={styles.propLine}>
          <span className={styles.propName}>גוש-חלקה:</span>
          <span className={styles.propDetails}>123456-1234</span>
        </div>
      </div>
      <div className={styles.tabsContainer}>
        <TabsHolder
          tabs={[
            {
              id: 0,
              title: 'ביקור בנכס',
              content: <TabProperty/>
            },
            {
              id: 1,
              title: 'מידע תכנוני ונתוני רישוי',
              content: <TabProperty/>
            },
            {
              id: 3,
              title: 'כללי',
              content: <TabProperty/>
            },
          ]}
        />
      </div>
    </div>
  </PageContainer>
);

DatabasePageView.propTypes = {
  searchText: PropTypes.string,
  onSearchChanged: PropTypes.func
};

export default DatabasePageView;
